import { render, staticRenderFns } from "./settle.vue?vue&type=template&id=6b12375d&scoped=true&"
import script from "./settle.vue?vue&type=script&lang=js&"
export * from "./settle.vue?vue&type=script&lang=js&"
import style0 from "./settle.vue?vue&type=style&index=0&id=6b12375d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12375d",
  null
  
)

export default component.exports